import styled from "styled-components";

export const H1Font = styled.div`
  color: ${p => p.theme.colors.secondary};
  font-size: 1.5rem;
  font-weight: bold;
`;

export const H1 = styled(H1Font as any) <{
  marginTop?: string,
  marginRight?: string,
  marginBottom?: string,
  marginLeft?: string,
  textAlign?: string,
}>`
  display: block;
  margin-top: ${p => p.marginTop || ".7rem"};
  margin-right: ${p => p.marginRight || "0rem"};
  margin-bottom: ${p => p.marginBottom || ".7rem"};
  margin-left: ${p => p.marginLeft || "0rem"};
  text-align: ${p => p.textAlign || "left"};
  cursor: default;
`;
